export default __webpack_public_path__ + "1b29a95dada8fc94ec05795f77f7b691.ico";